/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/{id}`
 */
export interface RulesSetIdGetRequest {
  /**
   * 规则集id
   */
  id: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/{id}`
 */
export interface RulesSetIdGetResponse {
  /**
   * 规则集id
   */
  id?: number;
  /**
   * 是否统一计算
   */
  unifiedCompute?: boolean;
  /**
   * 规则集名称
   */
  name?: string;
  /**
   * 租户名称
   */
  tenantName?: string;
  /**
   * 租户mcid
   */
  mcid?: string;
  /**
   * 规则集状态
   */
  status?: number;
  /**
   * 说明
   */
  detail?: string;
  /**
   * 规则集场景
   */
  sceneName?: string;
  /**
   * 规则集场景Id
   */
  sceneId?: number;
  /**
   * 规则模板id
   */
  dataRuleId?: number;
  /**
   * 规则模板名称
   */
  dataRuleName?: string;
  /**
   * 属性组名称
   */
  dataPropertyGroupName?: string;
  /**
   * 属性组id
   */
  dataPropertyGroupId?: number;
  /**
   * 封面图片
   */
  imageUri?: string;
  /**
   * 步骤
   */
  step?: number;
  /**
   * 间隔时间规则id
   */
  uploadTimeRuleId?: number;
  /**
   * 间隔时间规则名称
   */
  uploadTimeRuleName?: string;
  /**
   * 延时时间规则id
   */
  dataTimeRuleId?: number;
  /**
   * 延时时间规则名称
   */
  dataTimeRuleName?: string;
  /**
   * Y轴倍率名称，仅限数值型规则使用
   */
  yMagnificationName?: string;
  /**
   * Y轴倍率默认值，仅限数值型规则使用
   */
  yMagnificationValue?: number;
  /**
   * 1；累计值；2：瞬时值。
   */
  propertyType?: 1 | 2;
  /**
   * 数据点周期
   */
  dataPointPeriod?: number;
  /**
   * 数据点间隔
   */
  dataPointInterval?: number;
  /**
   * 累积量起始值默认值，仅限数值型规则使用
   */
  cumulativeStartValue?: number;
  /**
   * 累积量起始值名称
   */
  cumulativeStartName?: string;
  /**
   * 绑定设备列表
   */
  deviceList?: {
    id?: number;
    /**
     * 设备类目id
     */
    deviceTypeId?: number;
    /**
     * 设备类目id三级列表
     */
    deviceTypeList?: number[];
    /**
     * 设备类目名称
     */
    deviceTypeName?: string;
    /**
     * 设备列表
     */
    deviceList?: {
      id?: number;
      /**
       * 创建时间
       */
      createTime?: {
        seconds?: number;
        nanos?: number;
      };
      /**
       * 修改时间
       */
      updateTime?: {
        seconds?: number;
        nanos?: number;
      };
      /**
       * 设备名称
       */
      name?: string;
    }[];
    /**
     * 数据属性列表
     */
    dataPropertyList?: {
      /**
       * 主键
       */
      id?: number;
      /**
       * 名称
       */
      name?: string;
    }[];
    /**
     * 是否统一计算
     */
    unifiedCompute?: boolean;
    /**
     * Y轴倍率默认值，仅限数值型规则使用
     */
    yMagnificationValue?: number;
    /**
     * 1；累计值；2：瞬时值。
     */
    propertyType?: 1 | 2;
    /**
     * 累积量起始值默认值，仅限数值型规则使用
     */
    cumulativeStartValue?: number;
    /**
     * 累积量起始值名称
     */
    cumulativeStartName?: string;
    /**
     * Y轴倍率名称，仅限数值型规则使用
     */
    yMagnificationName?: string;
  }[];
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/{id}`
 */
type ApiRulesSetIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/{id}`
 */
const apiRulesSetIdGetRequestConfig: ApiRulesSetIdGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/{id}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetIdGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `GET /api/rulesSet/{id}`
 */
export const apiRulesSetIdGet = /*#__PURE__*/ (requestData: RulesSetIdGetRequest, ...args: UserRequestRestArgs) => {
  return request<RulesSetIdGetResponse>(prepare(apiRulesSetIdGetRequestConfig, requestData), ...args);
};

apiRulesSetIdGet.requestConfig = apiRulesSetIdGetRequestConfig;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/{id}`
 */
export interface RulesSetIdDeleteRequest {
  /**
   * 规则集id
   */
  id: string;
  username?: string;
  'authorities[0].role'?: string;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/{id}`
 */
export interface RulesSetIdDeleteResponse {}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/{id}`
 */
type ApiRulesSetIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/{id}`
 */
const apiRulesSetIdDeleteRequestConfig: ApiRulesSetIdDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet/{id}',
  method: Method.DELETE,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetIdDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `DELETE /api/rulesSet/{id}`
 */
export const apiRulesSetIdDelete = /*#__PURE__*/ (
  requestData: RulesSetIdDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<RulesSetIdDeleteResponse>(prepare(apiRulesSetIdDeleteRequestConfig, requestData), ...args);
};

apiRulesSetIdDelete.requestConfig = apiRulesSetIdDeleteRequestConfig;

/* prettier-ignore-end */
